<!--  -->
<template>
    <div class='wrapper box box_v'>
        <div class="header-wrapper">
            <div class="left">返回</div>
            <div class="header">活动预览</div>
        </div>
        <div class="hdxq">
            <img class="cover" />
            <div class='hdTitle'>标题标题标题标题标题标题标题标题标题,标题标题标题标题标题标题标题</div>
            <div class="activityType">分类</div>
            <div class='hdCommon' style="margin-top:10px">主办方：</div>
            <div class='hdCommon' >联系电话：</div>
            <div class='hdCommon'>活动时间：12:00 ~ 15:30</div>

            <div class='hdCommon box' @click='clickAddress'>
                <div class="box_f1">地址</div>
                <div class='iconfont icon-didian' style="color:#f44040;margin-left:3px"></div>
                <div class='' style="color:#f44040;margin-right:5px"> |</div>
                <div>地址</div>
            </div>

             <div class="baoming box">
                <!-- <view class='xian xian1 box_f1'></view> -->

                <!-- <div class="box box_v {{hdxqData.state != 3?'box-line':''}}">
                    <div class='hdEnd' wx:if="{{hdxqData.state != 3}}" style="line-height:28rpx">
                        <div class='hdEndTime'>报名截止日期剩余：</div>
                        <div>{{timerData.day<10?'0'+timerData.day:timerData.day}}天</div>
                        <div>{{timerData.hour<10?'0'+timerData.hour:timerData.hour}}时</div>
                        <div>{{timerData.minute<10?'0'+timerData.minute:timerData.minute}}分 </div>
                        <div>{{timerData.second<10?'0'+timerData.second:timerData.second}}秒</div>
                    </div>

                    <div class="hdNum">
                        <div class='hdMinge'>剩余名额：</div>
                        <div class='hdminge'>{{(hdxqData.limited)-(hdxqData.enrollment)<0?0:(hdxqData.limited)-(hdxqData.enrollment)}}</div>
                        <div class='hdMinge'>/{{hdxqData.limited}}</div>
                    </div>
                </div> -->
                <!-- <view class='xian xian2 box_f1'></view> -->
            </div>
        </div>
        
       
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        
    },
    data() {
    //这里存放数据
        return {
           
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        var h = document.documentElement.clientHeight || document.body.clientHeight
        //减导航栏，标题栏，详情卡片，上下padding
        this.cardHeight = h-60-84-340-20-20+'px'
        this.peopleListHeight = h-60-84-340-20-20-57+'px'
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height:84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.left{
    position:absolute;
    left:20px;
    font-size: 22px
}
.hdxq{
    width:424px;
    margin:0 auto;
    .cover{
        width:424px;
        height:264px;
    }
    .hdTitle{
        padding-top: 20px;
        font-size: 20px;
        color:#333;
    }
    .activityType {
        display: inline-block;
        border: 1px solid #a8c693;
        border-radius: 22px;
        font-size: 12px;
        height:22px;
        padding: 0 10px;
        margin-top: 20px;
        color: #a8c693;
    }
    .hdCommon {
        font-size: 14px;
        color: #555;
        line-height: 22px;
    }

    .hdaddress {
        position: relative;
        overflow: hidden;
    }
}
</style>